module.exports = __webpack_public_path__ + "static/media/shingleimg.827175e5.jpeg";